import type { ProviderAuthConfig, ProviderSupportSessionProjection } from "./providerAuth.ts";
import { validateSupportAuthority } from "../features/support/auth/authority.ts";

const supportIdPattern = "[a-f0-9]{8}-[a-f0-9]{4}-[1-5][a-f0-9]{3}-[89ab][a-f0-9]{3}-[a-f0-9]{12}";
const supportReturnPath = new RegExp(`^/support(?:/(?:studio|templates|incidents|reports|sla|(?:tickets/)?${supportIdPattern}(?:/workspace)?))?/?$`);

export function safeSupportReturn(value: string): string | null {
  let parsed: URL;
  try { parsed = new URL(value, "https://wenlix.invalid"); } catch { return null; }
  if (parsed.origin !== "https://wenlix.invalid" || parsed.hash ||
      !supportReturnPath.test(parsed.pathname) ||
      [...parsed.searchParams.keys()].some(key => key !== "session") ||
      parsed.searchParams.getAll("session").length > 1 ||
      (parsed.searchParams.has("session") && !/^[a-f0-9]{8}-[a-f0-9]{4}-[1-5][a-f0-9]{3}-[89ab][a-f0-9]{3}-[a-f0-9]{12}$/.test(parsed.searchParams.get("session") ?? ""))) return null;
  return parsed.pathname + parsed.search;
}
export function buildSupportProjection(raw: unknown, subject: string, config: ProviderAuthConfig): ProviderSupportSessionProjection {
  const session = validateSupportAuthority(raw, subject);
  return {
    supportOnly: true, accountUuid: subject, subject, accountType: "wenlix_internal_manager",
    organizationId: config.internalOrganizationId, clientId: config.clientId,
    consumerSurface: "internal_app", studioId: null, businessRole: "support_operator",
    businessApi: "support", permissions: [...session.actor.capabilities], uiRole: "manager",
    profile: { email: "", displayName: session.actor.display_name, firstName: "", lastName: "" },
  };
}
